import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addJob } from "../../Adapters/ApiAdapter";
import { baseUrl } from "../../variables/Variables";
import SeoTags from "../SeoTags/SeoTags";
import ReactQuill from "react-quill";
import CKEditorField from "../../components/CKEditorField";
// import { useNavigate } from "react-router-dom";

const AddCareerJob = () => {
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    department: "",
    designation: "",
    details: "",
    description: "",
    exp_required: "",
    skills: "",
    education: "",
    job_location: "",
    source_page: "",
    posted_by: "",
    banner_img: null,
    seo_title: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
    custom_scripts: "",
    og_title: "",
    og_description: "",
    og_type: "",
    og_url: "",
    og_image: "",
    og_locale: "",
    og_site_name: "",
    og_image_width: "",
    og_image_height: "",
    og_image_type: "",
    article_modified_time: "",
    canonical_link: "",
    twitter_card: "",
    twitter_site: "",
    twitter_title: "",
    twitter_description: "",
    twitter_image: "",
  });
  const [loading, setLoading] = useState(false);
  const [bannerImgFile, setBannerImgFile] = useState(null);
  const [twitterImgFile, setTwitterImgFile] = useState(null);
  const [ogImgFile, setOgImgFile] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      let updatedForm = { ...prev, [name]: value };

      if (name === "title") {
        updatedForm.slug = generateSlug(value);
      }

      return updatedForm;
    });
  };

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, " ")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };

  // const handleFileChange = (e, key, setPrevieState) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setPrevieState(file);
  //     setFormData((prev) => ({
  //       ...prev,
  //       [key]: file,
  //     }));
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const jobData = new FormData();

    // const stripHtml = (html) => html.replace(/<[^>]+>/g, "").trim();

    jobData.append("title", String(formData.title));
    jobData.append("slug", String(formData.slug));
    jobData.append("department", String(formData.department));
    jobData.append("designation", String(formData.designation));
    jobData.append("details", formData.details);
    jobData.append("description", formData.description);
    jobData.append("exp_required", formData.exp_required);
    jobData.append("skills", String(formData.skills));
    jobData.append("education", String(formData.education));
    jobData.append("job_location", String(formData.job_location));
    jobData.append("source_page", String(formData.source_page));
    jobData.append("posted_by", String(formData.posted_by));
    jobData.append("seo_title", String(formData.seo_title));
    jobData.append("meta_title", String(formData.meta_title));
    jobData.append("meta_description", formData.meta_description);
    jobData.append("meta_keywords", String(formData.meta_keywords));
    jobData.append("custom_scripts", formData.custom_scripts);
    jobData.append("og_title", String(formData.og_title));
    jobData.append("og_description", formData.og_description);
    jobData.append("og_type", String(formData.og_type));
    jobData.append("og_url", String(formData.og_url));
    jobData.append("og_locale", String(formData.og_locale));
    jobData.append("og_site_name", String(formData.og_site_name));
    jobData.append("og_image_width", formData.og_image_width);
    jobData.append("og_image_height", formData.og_image_height);
    jobData.append("og_image_type", String(formData.og_image_type));
    jobData.append("article_modified_time", formData.article_modified_time);
    jobData.append("canonical_link", String(formData.canonical_link));
    jobData.append("twitter_card", String(formData.twitter_card));
    jobData.append("twitter_site", String(formData.twitter_site));
    jobData.append("twitter_title", String(formData.twitter_title));
    jobData.append("twitter_description", formData.twitter_description);

    if (formData.banner_img) {
      jobData.append("banner_img", formData.banner_img);
    }
    if (formData.og_image) {
      jobData.append("og_image", formData.og_image);
    }
    if (formData.twitter_image) {
      jobData.append("twitter_image", formData.twitter_image);
    }
    // for (let [key, val] of formData.entries()) {
    //   console.log(`${key}:`, val);
    // }

    try {
      const response = await addJob(jobData);
      console.log("Blog AOI Res: ", response);
      if (response && response.status === "true") {
        toast.success("Job Added Successfully ");
        setFormData({
          title: "",
          slug: "",
          department: "",
          designation: "",
          details: "",
          description: "",
          exp_required: "",
          skills: "",
          education: "",
          job_location: "",
          source_page: "",
          posted_by: "",
          banner_img: null,
          seo_title: "",
          meta_title: "",
          meta_description: "",
          meta_keywords: "",
          custom_scripts: "",
          og_title: "",
          og_description: "",
          og_type: "",
          og_url: "",
          og_image: "",
          og_locale: "",
          og_site_name: "",
          og_image_width: "",
          og_image_height: "",
          og_image_type: "",
          article_modified_time: "",
          canonical_link: "",
          twitter_card: "",
          twitter_site: "",
          twitter_title: "",
          twitter_description: "",
          twitter_image: "",
        });
        setBannerImgFile(null);
        setOgImgFile(null);
        setTwitterImgFile(null);
      } else {
        toast.error("Failed to add Job");
      }
    } catch (error) {
      toast.error("An error occurred while adding the event.");
    } finally {
      setLoading(false);
    }

    // try {
    //     const jobData = new FormData();
    //     Object.keys(formData).forEach((key) => jobData.append(key, formData[key]));

    //     const response = await addJob(jobData);
    //     if (response?.message) {
    //         toast.success(response.message, { autoClose: 3000 });
    //         setTimeout(() => navigate("/career-jobs"), 3000); // Allow toast to show before redirect
    //     } else {
    //         toast.error("Failed to add job.");
    //     }
    // } catch (error) {
    //     toast.error("An error occurred while adding the job.");
    // } finally {
    //     setLoading(false);
    // }
  };

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Add Career Job
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        gap="16px"
        maxWidth="600px"
        mt="20px"
        component="form"
        onSubmit={handleSubmit}
      >
        <TextField
          label="Title"
          name="title"
          value={formData.title}
          onChange={handleInputChange}
          fullWidth
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Slug"
          name="slug"
          value={formData.slug}
          onChange={handleInputChange}
        />

        <TextField
          label="Department"
          name="department"
          value={formData.department}
          onChange={handleInputChange}
          fullWidth
          required
        />
        <TextField
          label="Designation"
          name="designation"
          value={formData.designation}
          onChange={handleInputChange}
          fullWidth
          required
        />

        <Typography variant="body1">Details</Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.details}
          onChange={(value) => setFormData({ ...formData, details: value })}
          style={{ height: "200px", marginBottom: "50px" }}
        /> */}
        <CKEditorField
            value={formData.details}
            onChange={(data) => setFormData((prev) => ({ ...prev, details: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=career`}
          />
        <Typography variant="body1">Description</Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.description}
          onChange={(value) => setFormData({ ...formData, description: value })}
          style={{ height: "200px", marginBottom: "50px" }}
        /> */}
        <CKEditorField
            value={formData.description}
            onChange={(data) => setFormData((prev) => ({ ...prev, description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=career`}
          />
        <TextField
          label="Experience Required"
          name="exp_required"
          type="text"                  // ✅ allows text like "0-1 Years"
          placeholder="e.g. 0-2"
          value={formData.exp_required}
          onChange={handleInputChange}
          fullWidth
        />
        <TextField
          label="Skills"
          name="skills"
          value={formData.skills}
          onChange={handleInputChange}
          fullWidth
        />
        <TextField
          label="Education"
          name="education"
          value={formData.education}
          onChange={handleInputChange}
          fullWidth
        />
        <TextField
          label="Job_loaction"
          name="job_location"
          value={formData.job_location}
          onChange={handleInputChange}
          fullWidth
        />
        {/* <TextField
          fullWidth
          label="Source_Page"
          name="source_page"
          value={formData.source_page}
          onChange={handleInputChange}
        />
        <TextField
          fullWidth
          label="Posted_By"
          name="posted_by"
          value={formData.posted_by}
          onChange={handleInputChange}
        /> */}

        <SeoTags
          formData={formData}
          setFormData={setFormData}
          setBannerImgFile={setBannerImgFile}
          setOgImgFile={setOgImgFile}
        />

        <Box mt={2}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Add Job"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddCareerJob;
